<template>
  <ul>
    <li><a href="https://causalanalysis.ai/">{{ $t("mainNav.link.support") }}</a></li>
  </ul>
</template>

<script>
export default {
  name: 'MainNav',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  display: inline-block;
  padding: 0;
  margin: 0 10px;
}

nav a {
  @extend %type-zeta;
  color: $text-light;
  text-decoration: none;

  &:hover,
  &.router-link-exact-active {
    color: $secondary;
  }
}
</style>
